import './FooterButton.scss';
import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { LFEBeaconButton } from 'components/shared/LFEBeaconComponents';
//import { ReactComponent as Arrow } from 'assets/arrow.svg';
const FooterButton = ({
  primary,
  text,
  icon,
  onClickAction,
  onClickURL,
  canContinue,
  openParent,
  newTab,
  testId,
}) => {
  const openType = newTab ? '_blank' : '_self';

  const handleClick = () => {
    if (openParent && onClickURL) {
      window.top.location.href = onClickURL;
    }
    onClickURL ? () => window.open(onClickURL, openType) : onClickAction();
  };

  return (
    <>
      {! primary
        ? (
        <LFEBeaconButton variant="secondary"
                         icon-align="left"
                         data-testid={testId}
                         disabled={!canContinue}
                         label={text}
                         onBeaconClick={() => handleClick()}
                         scale="normal"
          >
          {icon}
        </LFEBeaconButton>
       
        )
        : (
        <LFEBeaconButton variant="primary"
                         data-testid={testId}
                         disabled={!canContinue}
                         label={text}
                         onBeaconClick={() => handleClick()}
                         scale="normal"
          >
        </LFEBeaconButton>
        )}
    </>
  );
};

FooterButton.propTypes = {
  text: string.isRequired,
  icon: object,
  primary: bool,
  onClickAction: func,
  canContinue: bool,
  newTab: bool,
};

FooterButton.defaultProps = {
  text: '',
  primary: true,
  icon: null,
  onClickAction: null,
  canContinue: false,
  newTab: false,
};

export default FooterButton;
